import {
    AutocompleteTranslationModel,
    defaultAutocompleteTranslation,
} from '../../../models/autocomplete.translation.model';

interface AutocompleteConfig {
    translationData: AutocompleteTranslationModel;
}

const defaultAutocompleteConfig: AutocompleteConfig = {
    translationData: defaultAutocompleteTranslation,
};

export { type AutocompleteConfig, defaultAutocompleteConfig };
